import { useTranslation } from "react-i18next";
import { formatPrice } from "../../helpers/formattedPrice";

const STATUS_STYLES = {
  1: { bg: "#FFCC0033", color: "#FFCC00", key: "statusPending" },
  2: { bg: "#DEF9D5", color: "#60EC2F", key: "statusAccepted" },
  3: { bg: "#FFE5E5", color: "#FF4D4F", key: "statusRejected" },
  // 4: { bg: "#D6EAF8", color: "#2E86C1", key: "statusCollected" },
};

const GULF_CASH_COLLECTION = {
  CASH: 1,
  BANK: 2,
};

export default function WithdrawalHistoryCard({
  withdrawal,
  currency,
  onViewInvoice,
}) {
  const { t } = useTranslation();
  const isBank =
    withdrawal?.gulfCashCollectionTypeId === GULF_CASH_COLLECTION.BANK;
  const statusStyle = STATUS_STYLES[withdrawal?.statusId] || STATUS_STYLES[1];
  const statusLabel = t(`buyAndSupply2026.${statusStyle.key}`);
  const typeLabel =
    withdrawal?.gulfCashCollectionType ||
    (isBank
      ? t("buyAndSupply2026.bankTransfer")
      : t("buyAndSupply2026.cashWithdrawal"));

  const rows = isBank
    ? [
        {
          label: t("buyAndSupply2026.requestWithdrawal"),
          value: typeLabel,
        },
        {
          label: t("buyAndSupply2026.bankName"),
          value:
            withdrawal?.bankDetails?.bankName || t("buyAndSupply2026.emDash"),
        },
        {
          label: t("buyAndSupply2026.accountName"),
          value:
            withdrawal?.bankDetails?.accountName ||
            t("buyAndSupply2026.emDash"),
        },
        {
          label: t("buyAndSupply2026.iban"),
          value:
            withdrawal?.bankDetails?.accountNumberOrIBAN ||
            t("buyAndSupply2026.emDash"),
        },
        // {
        //   label: t("buyAndSupply2026.country"),
        //   value:
        //     withdrawal?.bankDetails?.gulfCountry ||
        //     t("buyAndSupply2026.emDash"),
        // },
      ]
    : [
        {
          label: t("buyAndSupply2026.requestWithdrawal"),
          value: typeLabel,
        },
        {
          label: t("buyAndSupply2026.date"),
          value: withdrawal?.creationDate || t("buyAndSupply2026.emDash"),
        },
      ];

  const showViewInvoice = withdrawal?.statusId === 2;

  return (
    <div className="buy-supply-2026-withdrawal-card">
      <div className="buy-supply-2026-withdrawal-card__header">
        <span className="buy-supply-2026-withdrawal-card__amount">
          {formatPrice(withdrawal?.amount)} {currency}
        </span>
        <span
          className="buy-supply-2026-withdrawal-card__status"
          style={{
            backgroundColor: statusStyle.bg,
            color: statusStyle.color,
          }}
        >
          {statusLabel}
        </span>
      </div>

      <ul className="buy-supply-2026-withdrawal-card__rows">
        {rows.map((row) => (
          <li key={row.label} className="buy-supply-2026-withdrawal-card__row">
            <span className="buy-supply-2026-withdrawal-card__label">
              {row.label}
            </span>
            <span className="buy-supply-2026-withdrawal-card__value">
              {row.value}
            </span>
          </li>
        ))}
      </ul>

      {showViewInvoice && (
        <button
          type="button"
          className="buy-supply-2026-withdrawal-card__invoice-btn"
          onClick={() => onViewInvoice?.(withdrawal)}
        >
          {t("buyAndSupply2026.viewInvoice")}
        </button>
      )}
    </div>
  );
}
